import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

export function hasBefehl22EmptyFields(befehl: Befehl): boolean {
  if (!befehl.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2210 = findAuftrag(befehl, '22.10')
  if (auftrag2210) {
    const has2211 = hasFieldContent(auftrag2210, '22.11', 'bf')
    const has2212 = hasFieldContent(auftrag2210, '22.12', 'bft')

    // Return true if BOTH fields are empty (22.11 AND 22.12 are empty)
    return !has2211 && !has2212
  }

  return false
}
